import GTM from '../../gtm/GTM';
import GTMSelectItemModel from '../../gtm/models/GTMSelectItemModel';
import GTMViewItemListModel from '../../gtm/models/GTMViewItemListModel';

interface RecentlyViewedHouseItemData {
    index: number;
    id: string;
    title: string;
}

export default class RecentlyViewedHousesTracking {
    private static readonly LIST_ID = 'recently_viewed_houses';

    private static readonly LIST_NAME = 'Recently Viewed Houses';

    public static trackSelectItem(houseCard: HTMLElement, index: number): void {
        const data = this.#getHouseInformation(houseCard, index);

        GTM.trackEcommerce(
            GTMSelectItemModel.parseToGTMData({
                listName: RecentlyViewedHousesTracking.LIST_NAME,
                listId: RecentlyViewedHousesTracking.LIST_ID,
                ...data
            })
        );
    }

    public static trackViewListItem(): void {
        const data = this.#getHousesInformation();

        GTM.trackEcommerce(
            GTMViewItemListModel.parseToGTMData({
                listName: RecentlyViewedHousesTracking.LIST_NAME,
                listId: RecentlyViewedHousesTracking.LIST_ID,
                itemCount: data.length,
                items: data.map((item) => item)
            })
        );
    }

    public static getHouseCards(): HTMLElement[] {
        const recentlyViewedHousesContainer = document.getElementById('nh-houses-carousel');
        return Array.from(recentlyViewedHousesContainer?.querySelectorAll('article') || []);
    }

    static #getHouseInformation(
        houseCard: HTMLElement,
        index: number
    ): RecentlyViewedHouseItemData {
        const houseId = houseCard.dataset.houseId || '';
        const title = houseCard.dataset.houseTitle || '';
        return { index, id: houseId, title: title };
    }

    static #getHousesInformation(): RecentlyViewedHouseItemData[] {
        const recentlyViewedHouses = RecentlyViewedHousesTracking.getHouseCards();

        return recentlyViewedHouses.map((houseCard, index) =>
            RecentlyViewedHousesTracking.#getHouseInformation(houseCard, index)
        );
    }
}
